import {IconButton, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {AgGridReact} from "ag-grid-react";
import { useMemo, useRef } from "react";
import {ColDef, ICellRendererParams, SideBarDef} from "ag-grid-community";
import {DescriptionRounded} from "@mui/icons-material";
import {Link} from "react-router-dom";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";

import {useHasScope} from "../../../../config/globalConfig";
import { NetworkScope } from "../../types";

const DmsTable = ({serverSideDatasource}: any) => {
    const {t, i18n} = useTranslation(['network', 'translation']);
    const hasScope = useHasScope;

    const sideBar = useMemo<SideBarDef>(() => ({
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnExpandAll: true,
                },
            },
        ],
        defaultToolPanel: '',
    }), []);

    const gridRef = useRef<AgGridReact>(null);
    const columnDefs = useMemo<ColDef[]>(() => [
        {
            field: 'generalInfo.id',
            headerName: "",
            width: 70,
            resizable: false,
            suppressMovable: true,
            suppressSizeToFit: false,
            suppressColumnsToolPanel: true,
            pinned: 'right',
            cellRenderer: (params: ICellRendererParams) => {
                const url = `/mobility-store/dms-detail/${params.data?.generalInfo?.id}`
                return (
                    hasScope( NetworkScope.MsDetail) &&
                    <Stack direction={"row"} justifyContent={"center"}>
                        <Link to={url} target="_blank">
                            <IconButton color="accent">
                                <DescriptionRounded />
                            </IconButton>
                        </Link>
                    </Stack>
                );
            }
        },
        {headerName: t('searchDms.form.label.dmsNaming'), field: 'generalInfo.name', sortable: true},
        {headerName: t('searchDms.form.label.dmsSapId'), field: 'generalInfo.sapId', sortable: true},
        {headerName: t('searchDms.form.label.dmsType'), field: 'generalInfo.dmsType', sortable: true},
        {headerName: t('searchDms.form.label.dmsCategory'), field: 'generalInfo.dmsCategory', sortable: true},
        {headerName: t('searchDms.form.label.currentStatus'), field: 'generalInfo.currentStatus', sortable: true},
        {headerName: t('searchDms.form.label.currentAttribute'), field: 'generalInfo.currentAttribute', sortable: true},
        {headerName: t('searchDms.form.label.region'), field: 'generalInfo.region', sortable: true},
        {headerName: t('searchDms.form.label.province'), field: 'generalInfo.province', sortable: true},
        {headerName: t('searchDms.form.label.city'), field: 'generalInfo.city', sortable: true},
        {headerName: t('searchDms.form.label.companyName'), field: 'generalInfo.companyName', sortable: true},
        {headerName: t('searchDms.form.label.address'), field: 'generalInfo.address', sortable: true},
        {headerName: t('searchDms.form.label.streetNumber'), field: 'generalInfo.streetNumber', sortable: true},
        {headerName: t('searchDms.form.label.chargingStationStatus'), field: 'eParking.chargingStationStatus', sortable: true},
        {headerName: t('searchDms.form.label.chargingColumnId'), field: 'eParking.chargingColumnId', sortable: true},
        {
            headerName: t('searchDms.form.label.certificationProtocolId'),
            field: 'eParking.certificationProtocolIdentifyingCode'
        },
        {headerName: t('searchDms.form.label.dmsKeyless'), field: 'keylessInfo.keyLess', sortable: true},
    ], [i18n.language] );

    return (
        <AgGridCustomTable
            gridRef={gridRef}
            rowModelType='serverSide'
            serverSideInfiniteScroll
            serverSideDatasource={serverSideDatasource}
            columnDefs={columnDefs}
            gridOptions={
                {
                    defaultColDef: { lockPinned: true, resizable: true, suppressSizeToFit: true },
                    onGridReady: (event) => {
                        event.api.sizeColumnsToFit()
                    }
                }
            }
            sideBar={sideBar}
        />
    )
}

export default DmsTable;
